import { Flex, HStack, Stack } from '@chakra-ui/react';
import { useInboxModel } from '@common/models/InboxModel';
import React from 'react';
import { TextBlock } from '../../../common/components/TextBlock';
import { MessageCard } from './MessageCard';

export const MessagesList: React.FC = () => {
  const inboxModel = useInboxModel();
  const messageCount = inboxModel.messages.length;

  return (
    <Stack>
      <HStack gap="5px">
        <TextBlock weight="bold" fontSize="28px">
          Messages
        </TextBlock>
        {messageCount > 0 && (
          <TextBlock
            fontSize={'12px'}
            weight="bold"
            color="white"
            display="inline-flex"
            backgroundColor={'gray.300'}
            width="25px"
            height="25px"
            borderRadius={'50%'}
            alignItems={'center'}
            justifyContent={'center'}>
            {messageCount}
          </TextBlock>
        )}
      </HStack>

      <Stack spacing={'10px'}>
        {inboxModel.messages.length > 0 ? (
          inboxModel.messages
            .filter((msg) => !msg.dismissed)
            .map((message, i) => {
              return <MessageCard card={message} key={`message-card-${i}`} />;
            })
        ) : (
          <Flex
            borderWidth={'1px'}
            borderColor={'black'}
            borderRadius={'10px'}
            direction="column"
            alignItems="center"
            p={'24px'}
            justifyContent="center">
            <TextBlock>No Messages</TextBlock>
          </Flex>
        )}
      </Stack>
    </Stack>
  );
};
